import { useQuery } from '@apollo/client'

import { gql } from '@/clients/utoniq-core'
import {
  ItemOrdersConnectionFragmentDoc,
  ItemOrdersQuery,
  ItemOrdersQueryVariables,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { data, loading, fetchMore } = useQuery<
    ItemOrdersQuery,
    ItemOrdersQueryVariables
  >(QUERY, {
    variables: { pageInput: { limit: 30 } },
  })

  const pageInfo = data?.userItemOrders?.pageInfo

  const fetchMorePosts = async () => {
    if (!(pageInfo && pageInfo.hasNextPage)) return

    fetchMore({
      variables: {
        pageInput: {
          cursor: pageInfo.endCursor || null,
        },
      },
    })
  }

  return {
    state: {
      itemOrders: data?.userItemOrders ?? null,
      loading,
      hasNextPage: !!data?.userItemOrders?.pageInfo.hasNextPage,
    },
    actions: {
      onFetchMore: fetchMorePosts,
    },
  }
})

const QUERY = gql`
  query ItemOrders($pageInput: PageInputDate) {
    userItemOrders(pageInput: $pageInput) {
      ...ItemOrdersConnection
    }
  }
  ${ItemOrdersConnectionFragmentDoc}
`
